import { ServiceDefinitionSaveDetails } from "../types/serviceDefinitionTypes";

export const serviceDefinitionSaveInitialValues: ServiceDefinitionSaveDetails = {
  id: "",
  content: "",
};
